__turbopack_context__.v({
  "container": "Switch-module__Nvlarq__container",
  "description": "Switch-module__Nvlarq__description",
  "disabled": "Switch-module__Nvlarq__disabled",
  "label": "Switch-module__Nvlarq__label",
  "labelText": "Switch-module__Nvlarq__labelText",
  "lg": "Switch-module__Nvlarq__lg",
  "md": "Switch-module__Nvlarq__md",
  "sm": "Switch-module__Nvlarq__sm",
  "switch": "Switch-module__Nvlarq__switch",
  "thumb": "Switch-module__Nvlarq__thumb",
});
